// 下游结算审批
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of search-area -->
    <el-tabs class="process-list" v-model="activeName" @tab-click="handleClick">
      <template v-for="(item, index) in listType">
        <el-tab-pane :label="item.label" :name="item.value"></el-tab-pane>
      </template>
    </el-tabs>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">企业名称</div>
          <el-select
            filterable
            clearable
            v-model="page.operationReportTenantGuid"
            placeholder="请选择药企"
            size="mini"
            class="ipt-sty"
          >
            <el-option
              v-for="item in sendTenantList"
              :key="item.guid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">核算月份</div>
          <el-date-picker
            size="mini"
            class="ipt-sty"
            v-model="page.accountMonth"
            type="month"
            format="yyyy-MM"
            placeholder="选择核算月份"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交日期</div>
          <el-date-picker
            size="mini"
            v-model="timeListS"
            type="daterange"
            format="yyyy-MM-dd"
            range-separator="至"
            class="ipt-sty"
            :picker-options="pickerOptions"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="searchData()">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">审批状态</div>
          <el-select
            filterable
            clearable
            v-model="page.approveState"
            placeholder="请选择审批状态"
            size="mini"
            class="ipt-sty"
          >
            <el-option v-for="item in approveList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">供应商</div>
          <el-select
            filterable
            clearable
            v-model="page.tenantGuid"
            placeholder="请选择供应商"
            size="mini"
            class="ipt-sty"
          >
            <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">流程名称</div>
          <el-select
            filterable
            clearable
            multiple
            collapse-tags
            v-model="page.flowTypeList"
            placeholder="请选择流程名称"
            size="mini"
            class="ipt-sty"
          >
            <el-option v-for="item in flowTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">发起人</div>
          <!-- <el-select multiple collapse-tags size="mini" v-model="page.applyStaffGuid" class="ipt-sty"
                        placeholder="请选择发起人" filterable>
                        <el-option v-for="item in staffList" :key="item.value" :label="item.text" :value="item.value">
                        </el-option>
                    </el-select> -->
          <el-input
            class="ipt-sty"
            size="mini"
            v-model="page.applyStaffName"
            placeholder="请输入内容"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">流程编号</div>
          <el-input size="mini" placeholder="请输入流程编号" class="ipt-sty" v-model="page.flowNo" />
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否已对冲</div>
          <el-select
            multiple
            collapse-tags
            size="mini"
            v-model="page.isHedgeFlow"
            class="ipt-sty"
            placeholder="请选择"
            filterable
          >
            <el-option v-for="item in isHedgeOp" :key="item.value" :label="item.text" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">费用总金额</div>
          <el-input
            type="number"
            multiple
            collapse-tags
            size="mini"
            v-model="page.totalAmount"
            onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
            @blur="page.totalAmount = $event.target.value"
            class="ipt-sty number number2"
            placeholder="请输入金额"
            filterable
          >
          </el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否平台任务</div>
          <el-select
            filterable
            clearable
            v-model="page.isPlatformTask"
            placeholder="请选择"
            size="mini"
            class="ipt-sty"
          >
            <el-option v-for="item in platformTaskList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">质量考核流程编号</div>
          <el-input size="mini" placeholder="请输入流程编号" class="ipt-sty" v-model="page.qualityAssessmentFlowNo" />
        </el-col>
      </el-row>
    </div>
    <!-- end of search-area -->

    <!-- start of content -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <!-- start of add-btn -->
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="initiate()">流程审批申请</el-button>
        <!-- <el-button size="mini" type="defalut" @click="approve()">批量审批</el-button> -->
      </div>
      <!-- end of add-btn -->

      <!-- start of table -->
      <el-table stripe border ref="multipleTable" v-loading="tableLoading" :data="tableData" :height="tableHeight">
        <!-- selection -->
        <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
        <!-- 序号 -->
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="flowNo"
          label="流程编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.approveVO.flowNo || '-' }}</template>
        </el-table-column>
        <!-- 流程名称 -->
        <el-table-column
          prop="flowName"
          min-width="107"
          label="流程名称"
          header-align="center"
          align="left"
          fixed="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.approveVO && scope.row.approveVO.flowName ? scope.row.approveVO.flowName : '-'
          }}</template>
        </el-table-column>
        <!-- 发起人 -->
        <el-table-column
          prop="applyStaffName"
          width="96"
          label="发起人"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.applyStaffName || '-' }}
          </template>
        </el-table-column>
        <!-- 审批状态 -->
        <el-table-column
          prop="approveState"
          width="80"
          label="审批状态"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销 -->
            <a class="reject-btn btn" v-if="scope.row.approveState == 'R'">已驳回</a>
            <a :class="scope.row.isHedge=='Y'?'cancel-btn btn':'pass-btn btn'" v-if="scope.row.approveState == 'Y'">已通过</a>
            <a class="ing-btn btn" v-if="scope.row.approveState == 'A'">审批中</a>
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'N'">草稿中</a>
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'C'">已撤销</a>
          </template>
        </el-table-column>
        <!-- 对冲状态 -->
        <el-table-column
          prop="approveState"
          width="90"
          label="是否已对冲"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isHedge === 'Y'">{{ '已对冲' }}</span>
            <span v-else-if="scope.row.isHedge === 'N'">{{ '未对冲' }}</span>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <!-- 对冲状态 -->
        <el-table-column
          prop="operationReportTenantName"
          width="180"
          label="企业名称"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        <template slot-scope="scope">
          <span v-if="scope.row.billType == 3">
            {{ scope.row.serviceTenantName || '-' }}
          </span>
            <span>{{ scope.row.operationReportTenantName }}</span>
          </template>
        </el-table-column>
        <!-- 供应商名称 -->
        <el-table-column
          prop="tenantName"
          width="160"
          label="供应商名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        
        <!-- 核算月份 -->
        <el-table-column
          prop="newAccountMonth"
          width="70"
          label="核算月份"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.newAccountMonth || '-' }}</template>
        </el-table-column>
        <!-- 期数 -->
        <el-table-column
          prop="billCycleList"
          width="120"
          label="期数"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ getBillCycleName(scope.row.billCycleList) }}</template>
        </el-table-column>
        <!-- 应付金额 -->
        <!-- //! 应付金额=费用总额-已付金额 -->
        <el-table-column
          prop="totalAmount"
          width="120"
          label="应付金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="hideAmountReconciliation(scope.row)">{{ '-' }}</div>
            <div v-else-if="scope.row.billType !== -1">{{ (scope.row.payable || '-') | numFmt | numDigit }}</div>
            <div v-else>{{ '-' }}</div>
          </template>
        </el-table-column>
        <!-- 结算周期 -->
        <el-table-column
          prop="settleCycle"
          min-width="220"
          label="结算周期"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.settleCycle || '-' }}</template>
        </el-table-column>
        <!-- 结算/付款时间 -->
        <el-table-column prop="settleDate" width="100" label="结算日期" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.settleDate | getDate }}</template>
        </el-table-column>
        <el-table-column prop="payTime" width="100" label="付款日期" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.payTime | getDate }}</template>
        </el-table-column>
        <!-- 人数 -->
        <el-table-column
          prop="personNum"
          width="60"
          label="人数"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- 结算金额 -->
        <el-table-column
          prop="settleAmount"
          min-width="96"
          label="结算金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="hideAmountReconciliation(scope.row)">
              -
            </span>
            <span v-else>
              {{ scope.row.settleAmount | numFmt | numDigit }}
            </span>
          </template>
        </el-table-column>
        <!-- 服务费率 -->
        <el-table-column
          prop="cooperationTaxRate"
          min-width="96"
          label="服务费率"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.cooperationTaxRate ? scope.row.cooperationTaxRate + '%' : '-' }}
          </template>
        </el-table-column>
        <!-- 服务费 -->
        <el-table-column
          prop="serviceAmount"
          width="110"
          label="服务费(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="hideAmountReconciliation(scope.row)">
              -
            </span>
            <span v-else>
              {{ scope.row.serviceAmount | numFmt | numDigit }}
            </span>
          </template>
        </el-table-column>
        <!-- 费用总金额 -->
        <el-table-column
          prop="totalAmount"
          width="120"
          label="费用总金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="hideAmountReconciliation(scope.row)">
              -
            </span>
            <span v-else>
              {{ scope.row.totalAmount | numFmt | numDigit }}
            </span>
          </template>
        </el-table-column>
        <!-- 已付金额-->
        <!-- 如果金额对冲流程为空，则展示“-” -->
        <!-- //! 已付金额=金额对冲流程时，选择的结算单时输入的已付款金额-已退回金额 -->
        <el-table-column
          prop="totalAmount"
          width="120"
          label="已付金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.billType !== -1">{{ (scope.row.paidAmount || '-') | numFmt | numDigit }}</div>
            <div v-else>{{ '-' }}</div>
          </template>
        </el-table-column>
        <!-- 提交时间 -->
        <el-table-column prop="submitDate" width="130" label="提交时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.submitDate | getTime }}</template>
        </el-table-column>

        <!-- 审批时间 -->
        <el-table-column prop="approveVO" width="130" label="操作时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveVO.approveTime | getTime }}</template>
        </el-table-column>
        <!-- 质量考核流程编号 -->
        <el-table-column
          prop="qualityAssessmentFlowNo"
          label="质量考核流程编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="130"
        >
          <template slot-scope="scope">{{ scope.row.qualityAssessmentFlowNo || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- 审批状态(N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销) -->
            <a class="txt-color" @click="see(scope.row,scope.$index)" v-if="getListBtnState('detail', scope.row) == 'detail'">
              详情
            </a>
            <a
              class="txt-color"
              @click="toPassSubmit(scope.row)"
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="toRejectSubmit(scope.row)"
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a class="txt-color" @click="cancel(scope.row)" v-if="getListBtnState('revoke', scope.row) == 'revoke'">
              撤销
            </a>
            <a
              class="txt-color"
              @click="againSubmit(scope.row, 1)"
              v-if="getListBtnState('edit', scope.row) == 'edit'"
            >
              编辑
            </a>
            <a
              class="txt-color"
              @click="del(scope.row.guid, scope.row)"
              v-if="getListBtnState('del', scope.row) == 'del'"
            >
              删除
            </a>
            
            <!-- <a
              class="txt-color"
              v-if="getListBtnState('again', scope.row) == 'again' && scope.row.bizApproveState != 'D'"
              @click="againSubmit(scope.row, 2)"
            >
              重新提交
            </a> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- end of table -->

      <!-- start of pagination -->
      <el-pagination
        class="pt pb back-color-fff content-pagination-box"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
      <!-- end of pagination -->
    </div>
    <!-- end of content -->

    <!-- start of dialog-流程审批申请选择 -->
    <el-dialog :title="'选择发起流程'" class="flow-dialog" :visible.sync="dialogFormVisible" width="650px">
      <div class="initiate-box">
        <div
          v-for="item in dialogFlowTypeList"
          :key="item.type"
          :class="['flow-item', { 'flow-item-active': flowSelectType === item.type }]"
          @click="flowSelect(item.type)"
        >
          {{ item.label }}
        </div>
      </div>
      <div slot="footer">
        <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="info" @click="selectApprove()">确定</el-button>
      </div>
    </el-dialog>
    <!-- end of dialog-流程审批申请选择 -->

    <!-- start of dialog-批量审批 -->
    <el-dialog :title="'批量审批'" class="flow-dialog" :visible.sync="dialogApprove" width="550px">
      <div class="initiate-box">
        <div :class="approveType == 1 ? 'flow-item flow-item-active' : 'flow-item'" @click="approveSelect(1)">通过</div>
        <div :class="approveType == 2 ? 'flow-item flow-item-active' : 'flow-item'" @click="approveSelect(2)">驳回</div>
      </div>
      <div slot="footer">
        <el-button plain size="mini" @click="dialogApprove = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitApprove()">确定</el-button>
      </div>
    </el-dialog>
    <!-- end of dialog-批量审批 -->

    <!-- end of dialog-驳回 -->
    <el-dialog title="填写驳回备注" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="rejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-驳回 -->

    <!-- end of dialog-通过 -->
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="passSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-通过 -->
  </div>
</template>

<script>
import workFlowCommon from '@/uilt/workFlowCommon';
import qs from 'qs';
import store from '@/store';
import getTenantDetail from '../../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../../mixins/getTenantDetail'
import { OrderTypeEnum } from './enum'
export default {
  mixins:[getTenantDetail],
  data() {
    let userInfo = JSON.parse(localStorage.userInfo);
    return {
      OrderTypeEnum,
      ServiceProviderTypeEnum,
      fullscreenLoading: false,
      activeName: '',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalRows: 0,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        // serviceTenantGuid: localStorage.guid,
        staffGuid: userInfo.staffGuid,
        applyStaffGuid: null,
        flowNo: null,
        qualityAssessmentFlowNo: null,
        isHedgeFlow: ['Y', 'N'],
        isPlatformTask: '',
      },
      showMore: false, // 是否展示更多
      tableHeight: window.innerHeight - 300,
      contentMainHeight: window.innerHeight - 200,
      tenantList: [],
      pickerOptions: {
        // 提交日期，今日以后的数据不可点
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      // (N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销)
      approveList: [
        {
          label: '全部',
          value: '',
        },
        // {
        //     label: '草稿中',
        //     value: 'N'
        // },
        {
          label: '审批中',
          value: 'A',
        },
        {
          label: '已通过',
          value: 'Y',
        },
        {
          label: '驳回',
          value: 'R',
        },
        {
          label: '已撤销',
          value: 'C',
        },
        {
          label: '草稿中',
          value: 'N',
        },
      ],
      listType: [
        {
          label: '全部流程',
          value: '0',
        },
        {
          label: '待处理',
          value: '4',
        },
        {
          label: '已处理',
          value: '2',
        },
        {
          label: '我收到的',
          value: '3',
        },
        {
          label: '我发起的',
          value: '1',
        },
      ],
      isHedgeOp: [
        {
          text: '已对冲',
          value: 'Y',
        },
        {
          text: '未对冲',
          value: 'N',
        },
      ],
      platformTaskList: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '是',
          value: 'Y',
        },
        {
          label: '否',
          value: 'N',
        }
      ],
      // 流程类型  00021:结算单流程,00022:付款单流程
      flowTypeList: [
        {
          label: '结算单流程',
          value: '00021',
        },
        {
          label: '付款单流程',
          value: '00022',
        },
        {
          label: '金额对冲流程',
          value: '00025',
        },
        {
          label: '对账单申请',
          value: '00030',
        },
      ],
      dialogFlowTypeList: [],
			flowPage:{
				settlementDocDetail:'/settlementDocDetail',
				hedgeAmountDetail:'/hedgeAmountDetail',
				downstreamPaymentDetail:'/downstreamPaymentDetail',
        downstreamPaymentDetail_old:'/downstreamPaymentDetail_old',
			},
      tableLoading: false,
      tableData: [],
      multipleSelection: [],

      dialogFormVisible: false, // 是否展示发起流程dialog
      flowSelectType: '', // 流程类型

      dialogApprove: false, // 是否展示批量审批dialog
      approveType: '', // 审批类型

      // 驳回通过
      userInfo: '',
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      postJson: {}, // 通过驳回时获取当前行的审批数据
      timeListS: [],
      staffList: [],
      sendTenantList: [],
      isLastNode: false, // 是否是最后一个节点
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 368;
        this.contentMainHeight = window.innerHeight - 300;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 300;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
		let	flowPage = {
				settlementDocDetail:'/settlementDocDetail',
				hedgeAmountDetail:'/hedgeAmountDetail',
				downstreamPaymentDetail:'/downstreamPaymentDetail',
        downstreamPaymentDetail_old:'/downstreamPaymentDetail_old',
		}
		let path = from.path.replace(/\W/,'')
    if (flowPage[path]) {
      next((vm) => {
        vm.getData(() => {
          if (vm.$store.getters.getPageY) vm.tableScrollToRow(vm.$refs.multipleTable, vm.$store.getters.getPageY); // 表格行跳转
        });
      });
    } else {
      next();
    }
  },
  async created() {
    await this.Mixins_getServiceProviderType();
    this.userInfo = JSON.parse(localStorage.userInfo);
    this.getData();
    this.getTenantList();
    this.getSendTenantList();
    this.getStaffList();
    this.getDialogFlowTypeList();
  },
  activated() {
    this.getData();
  },
  computed: {
    /**是否是 三方接包服务商*/
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    async judgeCurrentLastNode(item) {
      const userInfo = JSON.parse(localStorage.userInfo);
      const { approveVO } = item;
      const req = {
        deploymentId: approveVO.camundaDeploymentId,
        processInstanceId: approveVO.camundaInstanceId,
        staffGuid: userInfo.staffGuid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`,
        req
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.isLastNode = data.data;
    },
    getBillCycleName(list) { 
      if (!list||list.length == 0) return '-';
      return list.join('、');
    },
    /**
     * 对账单，第二个指定人未通过时,不展示金额/服务费率
     * @param {*} row
     */
    hideAmountReconciliation(row) {
      return row.approveVO?.flowType == OrderTypeEnum.RECONCILIATION && row.secondAssignApproveState != 'Y';
    },
    getStaffList() {
      let req = {
        tenantGuid: localStorage.guid,
        staffType: 1,
        bizState: 'Y',
      };
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff/get-select-staff`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log(res.data.data);
          this.staffList = res.data.data;
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },
    getDialogFlowTypeList() {
      let list = [
        { type: 3, label: '金额对冲流程' }
      ]
      if (this.isThirdPartyContractor) {
        list = [
          { type: 4, label: '对账单申请' },
          ...list
        ];
      } else {
        list = [
          { type: 1, label: '结算单流程' },
          { type: 2, label: '下游付款流程' },
          ...list
        ];
      }
      this.dialogFlowTypeList = list;
    },
    /**
     * 获取供应商接口
     */
    getTenantList() {
      let self = this;
      let postData = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseType: '9901,9904,9905',
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/delegation-company/list?${qs.stringify(postData)}`)
        .then((res) => {
          let { code, msg, data } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = data.records || [];
          } else {
            self.$message.error(msg);
          }
        });
    },
    /**
     * 获取供应商接口
     */
    getSendTenantList() {
      let self = this;
      let relType = null;
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        if (serviceProviderType == this.ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR) {
          relType = '123'; // 写死
          this.flowTypeList = [
            {
              label: '结算单流程',
              value: '00021',
            },
            {
              label: '收款单流程',
              value: '00022',
            },
            {
              label: '金额对冲流程',
              value: '00025',
            },
            {
              label: '对账单申请',
              value: '00030',
            },
          ]
        }
      } catch (error) { 
        console.log('error',error);
      }
      let postData = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, postData)
        .then((res) => {
          let { code, msg, data } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = data || [];
          } else {
            self.$message.error(msg);
          }
        });
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType
     * @param {*} row
     */
    getListBtnState(btnType, row) {
      let approveVO = row.approveVO;
      return workFlowCommon.getListBtnState(
        btnType,
        approveVO.approveState,
        approveVO.staffGuid,
        approveVO.approveStaffGuids,
        this.userInfo.staffGuid,
        approveVO.approveState,
      );
    },
    /**
     * 获取审批状态
     * @param {*} approvalState
     */
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },

    /**
     * tab条件筛选
     */
    handleClick() {
      this.page['listType'] = this.activeName;
      this.page['pageIndex'] = 1;
      this.getData();
    },
    searchData() {
      this.page['pageIndex'] = 1;
      this.tableData = [];
      this.getData();
    },
    /**
     * 获取列表数据
     */
    getData(callBack) {
      let self = this;
      self.tableLoading = true;
      if (this.timeListS && this.timeListS.length > 0) {
        this.page.startTime = this.$moment(this.timeListS[0]).format('YYYY-MM-DD HH:mm:ss');
        this.page.endTime = this.$moment(this.timeListS[1]).format('YYYY-MM-DD 23:59:59');
      }
      let postData = JSON.parse(JSON.stringify(this.page));
      if (this.page.accountMonth) {
        postData.accountMonth = this.$moment(this.page.accountMonth).format('YYYYMM');
      }
      // 是否对冲处理
      if (Array.isArray(postData.isHedgeFlow) && postData.isHedgeFlow.length === 2) {
        postData.isHedgeFlow = null;
      } else if (Array.isArray(postData.isHedgeFlow) && postData.isHedgeFlow.length === 1) {
        postData.isHedgeFlow = postData.isHedgeFlow[0];
      } else {
        postData.isHedgeFlow = null;
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/page-list`, postData).then((res) => {
        self.tableLoading = false;
        let { code, msg, data } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = data.records || [];
          list.forEach((item) => {
            let accountMonth = JSON.parse(item.accountMonth) || [];
            item.newAccountMonth = accountMonth.join(',');
          });
          self.tableData = list.map(item => {
            // 改名字
            const approveVO = { ...item.approveVO };
            if (this.isThirdPartyContractor && approveVO?.flowName) {
              // 是三方 三方接包服务商 时候 将 下游付款单流程 改成 下游收款单流程
              approveVO.flowName = approveVO.flowName.replace('付', '收');
            }
            return {
              ...item,
              approveVO,
            }
          })
          self.page.totalPage = data.totalPages;
          self.page.totalRows = data.totalRows;
					if (callBack) callBack()
        } else {
          self.$message.error(msg);
        }
      });
    },
    /**
     * 清空条件搜索，重新获取列表数据
     */
    empty() {
      let userInfo = JSON.parse(localStorage.userInfo);
      this.timeListS = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalRows: 0,
        // serviceTenantGuid: localStorage.guid,
        staffGuid: userInfo.staffGuid,
        applyStaffGuid: null,
        flowNo: null,
        qualityAssessmentFlowNo: null,
        isPlatformTask:''
      };
      this.tableData = [];
      this.getData();
    },
    /**
     * 详情
     * @param {*} item
     */
    see(item,index) {
			this.$store.commit('setPageY', index);
      // billType  1:结算单流程, 2:付款单流程 -1:对冲金额流程
      // 3 对账单
      if (item.billType == 3) {
        this.$router.push({
          path: '/settlementBillDetail', 
          query: {
            guid: item.guid,
            approveVO: JSON.stringify(item.approveVO),
            approveState:item.approveState,//草稿中N
            productGuid: this.$route.query.productGuid,
            secondAssignApproveState: item.secondAssignApproveState,
          },
        });
        return
      }
      if (item.billType == 1) {
        return this.$router.push({
          path: '/settlementDocDetail',
          query: {
            guid: item.guid,
            approveVO: JSON.stringify(item.approveVO),
            approveState:'',//草稿中N
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      if (item.billType == 2) {
        const maxDate = this.$moment('2025-11-01T00:00:00.000+08:00').format('YYYY-MM-DD HH:mm:ss')
        const currDate = this.$moment(item.submitDate).format('YYYY-MM-DD HH:mm:ss')
        // 旧数据查看详情
        if (!this.$moment(currDate).isAfter(maxDate)) { 
          this.$router.push({
            path: '/downstreamPaymentDetail_old',
            query: {
              guid: item.guid,
              approveVO: JSON.stringify(item.approveVO),
              productGuid: this.$route.query.productGuid,
            },
          });
          return 
        }
        return this.$router.push({
          path: '/downstreamPaymentDetail',
          query: {
            guid: item.guid,
            approveVO: JSON.stringify(item.approveVO),
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      if (item.billType === -1) {
        return this.$router.push({
          path: '/hedgeAmountDetail',
          query: {
            guid: item.guid,
            approveVO: JSON.stringify(item.approveVO),
            productGuid: this.$route.query.productGuid,
          },
        });
      }
    },
    /**
     * 校验付款单 付款状态是否允许操作
     * 2026-08-31 应测试要求，暂时注释掉"该流程已付款，不允许驳回/撤销"的前端拦截，一律放行；如需恢复，取消下方代码注释即可
     * @param {string} operationType - 操作类型：'revoke' 撤销 或 'reject' 驳回
     * @returns {boolean} - true表示允许操作，false表示不允许
     */
    checkPaymentStatus(operationType, row) {
      // let { financeApproveState, approveVO } = row;
      // const isPaid = financeApproveState === 'Y' && approveVO?.flowType === OrderTypeEnum.PAYMENT;
      // 付款单已经 财务付款确认审批通过了 不允许驳回/撤销
      // if (isPaid) {
      //   const actionMap = {
      //     'revoke': '撤销',
      //     'reject': '驳回'
      //   };
      //   const action = actionMap[operationType] || '操作';
      //   this.$message.error(`该流程已付款，不允许${action}`);
      //   return false;
      // }
      return true;
    },
    /**
     * 驳回提交
     */
    toRejectSubmit(row) {
      if (!this.checkPaymentStatus('reject', row)) return;
      this.rejectDialogVisible = true;
      this.approveSuggest = '';
      let { approveVO } = row;
      this.postJson = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
      };
    },
    rejectSubmit() {
      if (!this.approveSuggest) {
        return this.$message.error('请填写驳回理由');
      }
      let query = {
        ...this.postJson,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.userInfo.staffGuid,
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 通过提交
     */
    toPassSubmit(row) {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = row;
      // 对账单
      if (row.approveVO?.flowType == OrderTypeEnum.RECONCILIATION) {
        this.$router.push({
          path: '/settlementBillDetail', 
          query: {
            guid: row.guid,
            approveVO: JSON.stringify(row.approveVO),
            secondAssignApproveState: row.secondAssignApproveState,
          },
        });
        return
      }
      //2:付款单流程
      if (row.billType == 2) {
         this.$router.push({
          path: '/downstreamPaymentDetail',
          query: {
            guid: row.guid,
            approveVO: JSON.stringify(approveVO),
          },
        });
      } else {
        this.passDialogVisible = true;
        this.approveSuggest = '';
        this.postJson = {
          guid: approveVO.approveGuid,
          flowType: approveVO.flowType,
        };
      }
    },
    passSubmit() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        ...this.postJson,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.approveSuggest = '';
          this.$message.success('审批通过！');
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 撤销
     * @param {*} item
     */
    cancel(item) {
      if (!this.checkPaymentStatus('revoke', item)) return;
      let self = this;
      let { approveVO } = item;
      this.$confirm('撤销后,该流程将不再进行审核,确定这样操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await self.judgeCurrentLastNode(item);
          let query = {
            guid: approveVO.approveGuid,
            flowType: approveVO.flowType,
            approveStaffGuid: approveVO.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              self.getData();
              if(self.isLastNode && approveVO.flowType == OrderTypeEnum.PAYMENT) {
                // 最后流程节点 并且 是付款单流程 跳转到金额对冲
                self.$router.push('/hedgeAmount');
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    /**
     * 重新提交
     */
    againSubmit(item, type) {
      // billType  1 结算单 2 付款单 3 对账单
      if (item?.billType == 3) {
        // 对账单
         this.$router.push({
          path: '/settlementBillDetail',//结算单的编辑是进入详情页
          query: {
            guid: item.guid,
            approveVO: JSON.stringify(item.approveVO),
            approveState:item.approveState,//草稿中N
            productGuid: this.$route.query.productGuid,
            secondAssignApproveState: item.secondAssignApproveState,
          },
        });
        return
      }
      if (item.billType && item.billType == 1) {
        return this.$router.push({
          path: '/settlementDocDetail',//结算单的编辑是进入详情页
          query: {
            guid: item.guid,
            approveVO: JSON.stringify(item.approveVO),
            approveState:item.approveState,//草稿中N
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      // billType  1:结算单流程, 2:付款单流程
      // if (item.billType && item.billType == 1) {
      //   return this.$router.push({
      //     path: '/settlementDoc',
      //     query: {
      //       productGuid: this.$route.query.productGuid,
      //       guid: item.guid,
      //       type,
      //     },
      //   });
      // }
      if (item.billType && item.billType == 2) {
        return this.$router.push({
          path: '/downstreamPayment',
          query: {
            productGuid: this.$route.query.productGuid,
            guid: item.guid,
            type,
          },
        });
      }
      if (item.billType && item.billType === -1) {
        return this.$router.push({
          path: '/hedgeAmount',
          query: {
            productGuid: this.$route.query.productGuid,
            guid: item.guid,
            type,
          },
        });
      }
    },
    /**
     * 删除
     * @param {*} guid
     */
    del(guid, currentRow) {
      let { billType } = currentRow;
      let self = this;
      let urlObj = {
        1: '/downstream/settle/del',
        2: '/downstream/payment/del',
        '-1': '/downstream/settle/hedge/del',
        3: '/downstream/settle/del', // 对账单删除 和结算单 用一个接口
      };
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}${urlObj[billType]}`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getData();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    /**
     * 流程审批申请
     */
    initiate() {
      this.flowSelectType = '';
      this.dialogFormVisible = true;
    },
    /**
     * 选择发起流程类型
     */
    flowSelect(type) {
      this.flowSelectType = type;
    },
    /**
     * 选择发起流程
     */
    selectApprove() {
      // flowSelectType 1结算单流程 2下游付款流程 3金额对冲流程
      // 4 对账单申请
      if (this.flowSelectType == 1) {
        this.$router.push({
          path: '/settlementDoc',
          query: {
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      if (this.flowSelectType == 2) {
        this.$router.push({
          path: '/downstreamPayment',
          query: {
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      if (this.flowSelectType === 3) {
        this.$router.push({
          path: '/hedgeAmount',
          query: {
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      if (this.flowSelectType === 4) {
        this.$router.push({
          path: '/settlementBill',
          query: {
            productGuid: this.$route.query.productGuid,
          },
        });
      }
      this.dialogFormVisible = false;
    },
    /**
     * 选择审批类型
     */
    approveSelect(val) {
      this.approveType = val;
    },
    /**
     * 批量审批弹框调起
     */
    approve() {
      if (this.multipleSelection && this.multipleSelection.length == 0) {
        return this.$message.error('请先选择要审批的数据');
      }
      this.dialogApprove = true;
      this.approveType = '';
    },
    /**
     * 批量审批提交
     */
    submitApprove() {
      // 1通过 2驳回
      let approveType = '通过';
      if (this.approveType == 2) {
        approveType = '驳回';
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        if (item.approveVO) {
          arr.push(item.approveVO.approveGuid);
        }
      });
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        approveType: approveType,
        guids: arr,
        approveSuggest: approveType,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/batch-approve`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.approveSuggest = '';

          this.dialogApprove = false;
          this.multipleSelection = [];
          this.$refs.multipleTable.clearSelection();

          this.$message.success('批量' + approveType + '成功');
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 勾选当前列表数据
     * @param {*} val
     */
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        self.multipleSelection.push(item);
      });
    },
    /**
     * 修改当前页的数量
     * @param {*} val
     */
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    /**
     * 修改分页
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page.pageIndex = val || 1;
      this.getData();
    },
		/**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>

<style lang="less" scoped>
.search-area-div {
  flex-shrink: 0;
  margin-right: 4px;
  text-align:right;
  // width: 114px;
}
.ipt-sty{
  flex:1
}

.el-tab-sty {
  padding-left: 15px;
  border-radius: 6px 6px 0 0;
}

.flow-dialog {
  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  .initiate-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 85px 0px;
  }

  .flow-item {
    width: 200px;
    height: 90px;
    margin-right: 24px;
    text-align: center;
    line-height: 90px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    font-weight: 500;
  }

  .flow-item:hover,
  .flow-item-active {
    color: #fff;
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    border-radius: 2px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }
}

a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ipt-sty {
  width: 74% !important;
}

/deep/ .el-col-6 {
  display: flex;
}
.process-list {
  background: #fff !important;
  overflow-y: auto;
}
.process-list /deep/ .el-tabs__header {
  margin: 0 0 8px;
}
.process-list /deep/ .el-tabs__nav-scroll {
  padding: 0 12px;
}
.process-list /deep/ .el-tabs__nav-wrap::after {
  background-color: #e9eef3;
}
/deep/ .number input::-webkit-outer-spin-button,
/deep/ .number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ .number input[type='number'] {
  -moz-appearance: textfield;
}

/deep/ .number2 inpit {
  border: none;
}
</style>
